<template>
    <HeartRecoveryModal v-if="modalStore.modals[ModalEnum.HEART_RECOVERY]" />
    <AirdropClaimModal v-if="modalStore.modals[ModalEnum.AIRDROP_CLAIM]" />
    <BybitDealRewardClaimedNotificationModal v-if="modalStore.modals[ModalEnum.BYBIT_DEAL_REWARD_CLAIMED]" />
    <BybitDealNotificationModal v-if="modalStore.modals[ModalEnum.BYBIT_DEAL_NOTIFICATION]" />
</template>

<script setup lang="ts">
    import { watch } from 'vue';
    import { ModalEnum, useModalStore } from '@/js/store/quests/game/modules/ModalStore';
    import AirdropClaimModal from '@/js/quests/dashboard/modals/notifications/AirdropClaimModal.vue';
    import HeartRecoveryModal from '@/js/quests/dashboard/modals/notifications/HeartRecoveryModal.vue';
    import BybitDealNotificationModal from '@/js/quests/dashboard/modals/notifications/BybitDealNotificationModal.vue';
    import BybitDealRewardClaimedNotificationModal
        from '@/js/quests/dashboard/modals/notifications/BybitDealRewardClaimedNotificationModal.vue';
    import { useUserStore } from '@/js/store/quests/dashboard/UserStore';
    import { NotificationModalTypeEnum } from '@/js/quests/dashboard/types/enums';

    const modalStore = useModalStore();
    const userStore = useUserStore();

    function openModalAndWaitForClose(modalValue: NotificationModalTypeEnum) {
        return new Promise<void>((resolve) => {
            setTimeout(() => {
                let modalToToggle: ModalEnum | null = null;
                let modalToWatch: ModalEnum | null = null;

                switch (modalValue) {
                case NotificationModalTypeEnum.RegistrationRewardReceived:
                    modalToToggle = ModalEnum.REGISTER_BONUS;
                    modalToWatch = ModalEnum.INTRODUCTION;
                    break;
                case NotificationModalTypeEnum.HeartRecovered:
                    modalToToggle = ModalEnum.HEART_RECOVERY;
                    modalToWatch = ModalEnum.HEART_RECOVERY;
                    break;
                case NotificationModalTypeEnum.QuestSeasonUserRewardClaim:
                    modalToToggle = ModalEnum.AIRDROP_CLAIM;
                    modalToWatch = ModalEnum.AIRDROP_CLAIM;
                    break;
                case NotificationModalTypeEnum.BybitDealRewardClaimed:
                    modalToToggle = ModalEnum.BYBIT_DEAL_REWARD_CLAIMED;
                    modalToWatch = ModalEnum.BYBIT_DEAL_REWARD_CLAIMED;
                    break;
                case NotificationModalTypeEnum.BybitDeal:
                    modalToToggle = ModalEnum.BYBIT_DEAL_NOTIFICATION;
                    modalToWatch = ModalEnum.BYBIT_DEAL_NOTIFICATION;
                    break;
                default:
                    resolve();

                    return;
                }

                modalStore.toggleModal(modalToToggle, true);
                const stopWatch = watch(() => modalStore.modals[modalToWatch], (newValue) => {
                    if (!newValue) {
                        stopWatch();
                        resolve();
                    }
                });
            }, 1000);
        });
    }

    watch(() => userStore.notifications, async (newNotifications) => {
        if (modalStore.skipNotifications) {
            return;
        }
        if (newNotifications !== null) {
            // eslint-disable-next-line no-restricted-syntax
            for (const notification of newNotifications) {
                // eslint-disable-next-line no-await-in-loop
                await openModalAndWaitForClose(notification.type);
            }
        }
    }, { immediate: true });
</script>
